import React, { useEffect, useState, useCallback } from 'react'
import { parseSvgToJsx } from './utils/svg-parser.util.jsx'

import {
  StyledWidgetHeader,
  SvgLogo,
  VerticalDivider
} from './WidgetHeader.style'
import { useGetWhiteLabelLogoQuery } from '../../broadband/white-labeling.api.js'

export const WidgetHeader = props => {
  const { logo } = props
  const Logo = logo
  const queryParameters = new URLSearchParams(window.location.search)
  const whiteLabelClientId = queryParameters.get('utm_source')
  const getTypeFromPath = () => {
    const path = location.pathname
    if (path.startsWith('/mobile')) return 'mobile'
    if (path.startsWith('/broadband')) return 'broadband'
    return 'broadband' // default to broadband if no match
  }
  const { data: whiteLabelLogoSvg } = useGetWhiteLabelLogoQuery(
    {
      clientId: whiteLabelClientId,
      type: getTypeFromPath()
    },
    {
      skip: !whiteLabelClientId
    }
  )
  const getPartnersLogo = useCallback(() => {
    if (whiteLabelLogoSvg) {
      const jsxSvg = parseSvgToJsx(whiteLabelLogoSvg)
      setWhiteLabelLogo(jsxSvg)
    }
  }, [whiteLabelLogoSvg])
  useEffect(() => {
    if (whiteLabelClientId) {
      getPartnersLogo()
    }
  }, [getPartnersLogo, whiteLabelClientId])
  const [whiteLabelLogo, setWhiteLabelLogo] = useState(null)

  return (
    <StyledWidgetHeader>
      {whiteLabelLogo && <SvgLogo>{whiteLabelLogo}</SvgLogo>}
      {whiteLabelLogo && <VerticalDivider />}
      <SvgLogo>
        <Logo />
      </SvgLogo>
    </StyledWidgetHeader>
  )
}
